import React from 'react';
import { observer } from 'mobx-react-lite';
import { Navigate } from 'react-router-dom';
import ItemPage from 'pages/ItemPage';
import DeleteForeverDialog from 'components/deletion/DeleteForeverDialog';
import OrganizationDeleteDialog from 'components/deletion/OrganizationDeleteDialog';
import { OrganizationDeletionStatusFormatter } from 'components/deletion/tenantDeletionLabels';
import {
  addMeAsSuperUserAction,
  deployOrganizationAction,
} from 'components/deletion/organizationListActions';
import { useOrganizationDeletion } from 'components/deletion/useOrganizationDeletion';

const EditOrganizationScreen = ({ item }: { item: { key?: string } }) => (
  <Navigate to={`../organization/${item?.key || 'new'}`} replace />
);

const OrganizationItemPage = observer(() => {
  const {
    deletionActions,
    deleteFlow,
    setDeleteFlow,
    deleteDialog,
    setDeleteDialog,
    handleSoftDelete,
    handleHardDelete,
  } = useOrganizationDeletion();

  return (
    <>
      <ItemPage
        modelName="organization"
        EditScreen={EditOrganizationScreen}
        hideDefaultDelete
        filters={['searchText']}
        secondaryFields={[
          { name: 'status', label: 'Status', formatter: OrganizationDeletionStatusFormatter },
        ]}
        additionalActions={[
          deployOrganizationAction,
          addMeAsSuperUserAction,
          ...deletionActions,
        ]}
      />
      {deleteFlow && (
        <OrganizationDeleteDialog
          open
          orgName={deleteFlow.org.name}
          loading={deleteFlow.loading}
          loadError={deleteFlow.loadError}
          previewData={deleteFlow.previewData}
          onClose={() => setDeleteFlow(null)}
          onConfirm={handleSoftDelete}
        />
      )}
      {deleteDialog && (
        <DeleteForeverDialog
          open
          title="Hard delete organization now"
          message={`This will immediately and permanently delete "${deleteDialog.org.name}" and all related data.`}
          confirmLabel="Hard delete now"
          onClose={() => setDeleteDialog(null)}
          onConfirm={handleHardDelete}
        />
      )}
    </>
  );
});

export default OrganizationItemPage;
